(() => {
  const lipStainRecommendations = {
    fair: {
      soft: { shade: 'Light Rose', wait: '10 to 15 seconds', also: 'Warm Rose', text: 'A soft light rose that brings back your natural lip colour without looking like makeup.' },
      everyday: { shade: 'Warm Rose', wait: '10 to 15 seconds', also: 'Light Rose', text: 'A warm rose that gives fair skin a fresh, healthy flush.' },
      bold: { shade: 'Classic Red', wait: '30 to 45 seconds', also: 'Warm Rose', text: 'A classic red that looks striking and polished against fair skin.' }
    },
    light_medium: {
      soft: { shade: 'Light Rose', wait: '10 to 15 seconds', also: 'Warm Rose', text: 'A light rose that looks like your own lips on their best day.' },
      everyday: { shade: 'Warm Rose', wait: '30 seconds', also: 'Light Rose', text: 'A warm rose that adds noticeable colour while still looking natural.' },
      bold: { shade: 'Classic Red', wait: '30 to 45 seconds', also: 'Warm Rose', text: 'A classic red that brightens your whole face in one step.' }
    },
    medium_tan: {
      soft: { shade: 'Warm Rose', wait: '15 seconds', also: 'Rosy Brown', text: 'A warm rose that blends with your natural lip tone for a soft, fresh look.' },
      everyday: { shade: 'Rosy Brown', wait: '30 seconds', also: 'Warm Rose', text: 'A rosy brown that brings back depth and definition to your lips.' },
      bold: { shade: 'Classic Red', wait: '30 to 45 seconds', also: 'Rosy Brown', text: 'A classic red that looks rich and confident against warm skin.' }
    },
    deep: {
      soft: { shade: 'Rosy Brown', wait: '10 to 15 seconds', also: 'Classic Red', text: 'A sheer rosy brown that evens out your lip colour naturally.' },
      everyday: { shade: 'Rosy Brown', wait: '30 to 45 seconds', also: 'Classic Red', text: 'A rich rosy brown that gives your lips a full, defined look all day.' },
      bold: { shade: 'Classic Red', wait: '30 to 45 seconds', also: 'Rosy Brown', text: 'A classic red that looks stunning and bold against deep skin.' }
    }
  };

  if (!customElements.get('lip-stain-shade-finder')) {
    customElements.define('lip-stain-shade-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-lsf-open]');
        if (!this.dialog || !this.trigger) return;
        this.initialized = true;
        this.addEventListener('click', this.onClick.bind(this));
        this.dialog.addEventListener('close', () => {
          this.trigger.setAttribute('aria-expanded', 'false');
          if (this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
        });
      }

      disconnectedCallback() {
        if (this.dialog && this.dialog.open) this.dialog.close();
      }

      showStep(name, focus = true) {
        this.querySelectorAll('[data-lsf-step]').forEach(step => {
          step.hidden = step.dataset.lsfStep !== name;
        });
        this.dialog.scrollTop = 0;
        if (focus) this.querySelector('[data-lsf-step="' + name + '"] [data-lsf-focus]').focus({ preventScroll: true });
      }

      onClick(event) {
        if (event.target === this.dialog) {
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
          return;
        }
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-lsf-open')) {
          this.tone = null;
          this.showStep('tone', false);
          this.dialog.showModal();
          this.trigger.setAttribute('aria-expanded', 'true');
          this.showStep('tone');
        } else if (button.hasAttribute('data-lsf-close')) {
          this.dialog.close();
        } else if (button.hasAttribute('data-lsf-back')) {
          this.tone = null;
          this.showStep('tone');
        } else if (button.dataset.lsfTone) {
          this.tone = button.dataset.lsfTone;
          this.showStep('intensity');
        } else if (button.dataset.lsfIntensity && this.tone) {
          const recommendation = lipStainRecommendations[this.tone]?.[button.dataset.lsfIntensity];
          if (!recommendation) return;
          this.querySelector('[data-lsf-shade-name]').textContent = recommendation.shade;
          this.querySelector('[data-lsf-text]').textContent = recommendation.text;
          this.querySelector('[data-lsf-wait]').textContent = recommendation.wait;
          this.querySelector('[data-lsf-also-prefix]').textContent = this.tone === 'deep' && button.dataset.lsfIntensity === 'soft'
            ? this.dataset.lsfBolderLabel
            : this.dataset.lsfAlsoLabel;
          this.querySelector('[data-lsf-also]').textContent = recommendation.also;
          this.showStep('result');
        }
      }
    });
  }
})();
